import React from "react";
import data from "./data";

const TeamTwo = ({ item, column, teamStyle, position = "start" }) => {
  const teamData = data();

  // Elegimos qué parte del array mostrar
  const itemSlice =
    position === "end"
      ? teamData.slice(-item) // últimos `item` elementos
      : teamData.slice(0, item); // primeros `item` elementos (por defecto)

  return (
    <div className="row">
      {itemSlice.map((value, i) => (
        <div className={`${column}`} key={i}>
          <div className={`team-static ${teamStyle}`}>
            <div className="thumbnail">
              <img src={value.images} alt="Items Images" />
            </div>
            <div className="inner">
              <div className="content">
                <h4 className="title">{value.title}</h4>
                <p className="designation">{value.designation}</p>
              </div>
              <ul className="social-transparent liststyle d-flex">
                {value.socialNetwork.map((social, index) => (
                  <li key={index}>
                    <a href={social.url}>{social.icon}</a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TeamTwo;
